import React, { useState, useEffect, useRef } from 'react';
import { collection,updateDoc, addDoc, query, orderBy, onSnapshot,where,limit,Timestamp, getDocs,getDoc,  doc, setDoc } from "firebase/firestore";
import { db } from './firebaseconfig'; // Import Firestore from Firebase
import axios from 'axios';
import '../ChatBot/styleschatbot.css';
import { useDispatch, useSelector } from "react-redux";
import { Endpoints } from '../../Global/Endpoints';
import { useNavigate } from "react-router-dom";
import { useChat } from '../Layout/ChatContext';
import { useTranslation } from 'react-i18next';

const ChatBotWindow = () => {
    const userInfo = useSelector((state) => state.userData);
    const userInitial = userInfo?.userData?.FirstName?.charAt(0)?.toUpperCase() || '';
    const token = localStorage.getItem('AccessToken');
    const dispatch = useDispatch();
    const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [input, setInput] = useState('');
  const [isChatOpen, setIsChatOpen] = useState(true);
  const [questionsVisible, setQuestionsVisible] = useState(true);
    const [isMessagesOpen, setIsMessagesOpen]=useState(true);
    const { t } = useTranslation();
    const ssoData = useSelector((state) => state.sso.ssoUserData);
      const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const { hideChat } = useChat();

const handleClose = () => {
  setIsChatOpen(false);
  hideChat(); // or implement your logic to close/hide the chat
};
 console.log(userInfo);
  // Reference to the latest message
  const latestMessageRef = useRef(null);

  

   useEffect(() => {
    const initializeUser = async () => {
        if (!userInfo?.userData.WINChatToken) {
          await createNewUser();
        }
        
      };
    
      initializeUser();
    }, [userInfo?.userData.WINChatToken]);

  const questions = [
    "What are my benefits?",
    "How can I search for a network provider?",
    "What is the status of my prior authorization?",
    "I'd like to schedule a nurse consultation",
    "I have a different question that is not listed here",
  ];

  const handleQuestionClick = (question) => {
    setMessages((prev) => [...prev, { text: question, sender: "user" }]);
    //setInput(question); // Set input to the question
    handleSend(question);
    setQuestionsVisible(false); // Hide questions after a question is selected
  };

  const reloadQuestions = () => {
    setQuestionsVisible(true);
  };


//   contract: "ZYX Sales Corp - Premier",
//   member_id: "ZYX6543210",
// Create a new user in Firebase
  const createNewUser = async () => {
    try {
      const userDocRef = doc(collection(db, "users"));
      const newUser = {
        id: userDocRef.id,
        name:  `${userInfo.userData.FirstName} ${userInfo.userData.LastName} ${userInfo.userData.DOB}`,
        contract: userInfo.userData.ContractIdentified,
        member_id: userInfo.userData.MemberID,
        chat_state: 0
      };

      
      const newTokenId = userDocRef.id; // Use the document ID as the tokenId
      console.log("userDocRef",userDocRef.id)
      
      if (newTokenId) {
        // Save the new tokenId to the backend
        await saveTokenToBackend(newTokenId);
        await setDoc(userDocRef, newUser);
      }
    } catch (error) {
      console.error("Error creating new user:", error);
    }
  };

  // Function to save the token to the backend
const saveTokenToBackend = async (tokenId) => {
    try {
        const params = {
            WINChatToken: tokenId,
            AppUserId: userInfo.userData.AppUserId,
            EmailID: userInfo.userData.EmailID,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
          };

        const response = await axios.post(
            Endpoints.SaveWinChatToken,
            { _Params: JSON.stringify(params) },
            
              {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Connection": "close",
                "Accept": "*/*",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
      if (response.data) {
        console.log(" saved token to backend");
        console.log("res of save tokenid",response);
          dispatch({
        type: "UPDATE_USER_DATA", 
        payload: { ...userInfo.userData, WINChatToken: tokenId,  },
      });
      }
  
      console.log("failed res of save tokenid",response);
    } catch (error) {
      console.error("Error saving token to backend:", error);
    }
  };

  const handleSend = async (meassage =null) => {
    setQuestionsVisible(false);
    setIsLoading(true)
    const messageText = meassage || input;
    if (!messageText.trim()) return; // Prevent sending empty messages
    const messageDocRef = doc(collection(db, "users", userInfo.userData.WINChatToken, "messages"));
    const newMessage = {
         id: messageDocRef.id,
         text: messageText,
         user_id: userInfo.userData.WINChatToken,
         sender_id:userInfo.userData.WINChatToken,
         sender: "user", 
         sender_type: 0,
         created_at: new Date() };
    setMessages([...messages, newMessage]);
    setInput('');
    try {
      console.log("newMessage",newMessage)
      await setDoc(messageDocRef, newMessage);

      // Prepare the payload for the API call
    const params = {
        question: messageText,
        user_id: userInfo.userData.AppUserId ,
        member_id: userInfo.userData.MemberID,
        contract: userInfo.userData.ContractIdentified,
        EmailID: userInfo.userData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal", 
      };
  
      const response = await axios.post(
        Endpoints.handleSend,
        { _Params: JSON.stringify(params) },
        
          {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

   // Check the response structure and handle accordingly
   if (response?.data) {
    console.log("Api res",response?.data)
    const botResponse = response?.data?.response;
    const botOptions = response?.data?.options;
    const sentimentTrigger = response?.data?.metadata?.sentiment_trigger;
    const botMessageDocRef = doc(collection(db, "users", userInfo.userData.WINChatToken, "messages"));
    const botMessage = {
        id: botMessageDocRef.id,
        user_id: userInfo.userData.WINChatToken,
        text: botResponse,
        sender: "bot", 
        sender_type: 2,
        created_at: new Date(),
        options: botOptions || null,
    };
    // Add bot response to the message list
    setMessages((prevMessages) => [...prevMessages, botMessage]);
    setIsLoading(false)

    const firebaseMessage = { ...botMessage };
      console.log("firebaseMessage",firebaseMessage)
      await setDoc(botMessageDocRef, firebaseMessage);

  // Fetch current chat_state from Firestore
  const userRef = doc(db, "users", userInfo.userData.WINChatToken);
  const userDoc = await getDoc(userRef);

  if (userDoc.exists()) {
      const currentChatState = userDoc.data().chat_state;

      // Only update chat_state if necessary
      if (sentimentTrigger && currentChatState !== 1) {
          await updateDoc(userRef, { chat_state: 1 });
          console.log("User chat_state updated to 1 due to sentiment trigger.");
      } else if (!sentimentTrigger && currentChatState !== 0) {
          await updateDoc(userRef, { chat_state: 0 });
          console.log("User chat_state reset to 0 (no sentiment trigger).");
      }
  }

  } else {
    throw new Error("Invalid API response structure.");
  }
} catch (error) {
  console.error("Error fetching bot response:", error);

  // Add appropriate error messages based on conditions
  let errorMessageText = "An error occurred while processing your request. Please try again later.";

  if (error.response) {
    // API responded with a status code outside the 2xx range
    if (error.response.status === 401) {
      errorMessageText = "Unauthorized access. Please check your credentials.";
    } else if (error.response.status === 404) {
      errorMessageText = "The requested resource was not found.";
    } else if (error.response.status >= 500) {
      errorMessageText = "Server is currently unavailable. Please try again later.";
    }
  } else if (error.request) {
    // No response received from the API
    errorMessageText = "No response from the server. Please check your network connection.";
  } else {
    // Error in setting up the request
    errorMessageText = `Request error: ${error.message}`;
  }
}
};

const handleOptionClick = async (key, value) => {
  const userRef = collection(db, "users", userInfo.userData.WINChatToken, "messages");

    if (key === "yes") {
      const userDocRef = doc(userRef);
        const userMessage = {
            id: userDocRef.id,
            user_id: userInfo.userData.WINChatToken,
            text: "Yes", 
            sender_id: userInfo.userData.WINChatToken,
            sender: "user",
            sender_type: 0,
            created_at: new Date(),
        };

        await setDoc(userDocRef, userMessage);
         // Define navigation keywords and their corresponding routes
         const navigationKeywords = {
            "authorization screen": "/treatment-authorization",
            "payment portal": "/payment-portal",
            "profile settings": "/profile-settings",
            "appointments": "/upcoming-appointments",
            "consultation screen": "/book-appointment",
            "provider search":"/load-findcare-list",
            "High-Risk Pregnancy Assessment":"/maternity-assessment"
        };

        // Iterate through the navigationKeywords to check for matching keywords in the message
        for (let keyword in navigationKeywords) {
            if (value.toLowerCase().includes(keyword)) {
                // Special case for "provider search" to include the selectedProviderType
                if (keyword === "provider search") {
                    navigate(navigationKeywords[keyword]);
                } else {
                    // Perform the regular navigation
                    navigate(navigationKeywords[keyword]);
                }
                return; // Exit the function after navigating
            }
        }

    } else if (key === "no") {

      const userDocRef = doc(userRef);
      const botDocRef = doc(userRef);

        // Save "No" as user response
        const userMessage = {
            id: userDocRef.id,
            user_id: userInfo.userData.WINChatToken,
            text: "No", // Save "No" for the user
            sender_id: userInfo.userData.WINChatToken,
            sender: "user",
            sender_type: 0,
            created_at: new Date(),
        };
        setMessages((prevMessages) => [...prevMessages, userMessage]);
        //await addDoc(collection(db, "users", userInfo.userData.WINChatToken, "messages"), userMessage);

        await setDoc(userDocRef, userMessage);

        // Add follow-up bot message to the chat
        const botMessage = {
            id: botDocRef.id,
            user_id: userInfo.userData.WINChatToken,
            text: value, 
            sender: "bot",
            sender_type: 2,
            created_at: new Date(),
        };

        setMessages((prevMessages) => [...prevMessages, botMessage]);

        // Save bot follow-up response to Firestore
        await setDoc(botDocRef, botMessage);
    }
};

  useEffect(() => {
    const fetchMessages = async () => {
      // Ensure that WINChatToken exists
      if (!userInfo?.userData?.WINChatToken) {
        console.log("WINChatToken is missing. Unable to fetch messages.");
        return;
      }
  
      try {
        // Construct the Firestore query
        let messagesQuery = query(
          collection(db, "users", userInfo.userData.WINChatToken, "messages"),
          where("user_id", "==", userInfo.userData.WINChatToken),
          orderBy("created_at", "desc"),
          limit(50)
        );
    
        // Add additional condition for filtering messages older than a specific date
        if (null) {
          messagesQuery = query(
            messagesQuery,
            where("created_at", "<", Timestamp.fromDate(new Date(null)))
          );
        }
        const unsubscribe = onSnapshot(messagesQuery, (querySnapshot) => {
          const fetchedMessages = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setMessages(fetchedMessages.reverse());
        });
        return () => unsubscribe();
      } catch (error) {
        console.error("Error fetching messages:", error);
        throw new Error("Failed to fetch messages from Firestore.");
      }
    };
  
    fetchMessages();
  }, [userInfo?.userData?.WINChatToken]);
  useEffect(() => {
    if (latestMessageRef.current) {
      latestMessageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const formatMessageText = (text) => {
    if (!text) return "";

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    const phoneRegex = /(\+?\d{1,3}[\s-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g;

    return text
      .replace(urlRegex, (url) => `<a href="${url}" target="_blank">${url}</a>`)
      .replace(emailRegex, (email) => `<a href="mailto:${email}">${email}</a>`)
      .replace(phoneRegex, (phone) => {
        const cleaned = phone.replace(/[^\d+]/g, "");
        return `<a href="tel:${cleaned}">${phone}</a>`;
      });
  };

  return isChatOpen &&(
    <div className="col-md-12 col-lg-12 mt-md-4 mt-sm-0 inner-page-heading-wrapper">
      <div className="chat-container">
          <div className="chat-header">
      <h2>{t('chatHeading')}</h2>
      <button className="close-btn" onClick={handleClose}>
        &times; 
      </button>
    </div>
       {/* Chat Messages Section */}
       { isMessagesOpen&& (
          <>
            <div className="chat-window">
            {messages.map((msg, index) => {
              const senderClass =
                msg.sender ||
                (msg.sender_type === 0 ? "user" : msg.sender_type === 2 || 1 ? "bot" : "unknown");

              return (
                <div
                  key={index}
                  className={`message ${senderClass}`}
                  style={senderClass === "user" ? { "--user-initial": `'${userInitial}'` } : {}}
                  ref={index === messages.length - 1 ? latestMessageRef : null}
                  dangerouslySetInnerHTML={{ __html: formatMessageText(msg.text) }}
                >
                </div>
              );
            })}

              {questionsVisible && (
                 <div className="message bot">
                  {isHighmarkPortal
      ? <div>{t('welcomeMessageHighmark')}</div>
      : <div>{t('welcomeMessage')}</div>
    }
                {questions.map((question, index) => (
                    <button
                      key={index}
                      onClick={() => handleQuestionClick(question)}
                      className="question-btn"
                    >
                      {question} <span style={{ float: "right" }}>→</span>
                    </button>
                  ))}
                  </div>
              )}
              {/* Render options as separate component */}
            {messages[messages.length - 1]?.options && (
              <div className="options user-side">
                {Object.entries(messages[messages.length - 1].options).map(
                  ([key, value]) => (
                    <button
                      key={key}
                      className="option-btn"
                      onClick={() => handleOptionClick(key, value)}
                    >
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                    </button>
                  )
                )}
              </div>
            )}
            {isLoading && 
              <div className="three-dot-loader">
                <span></span>
                <span></span>
                <span></span>
              </div>}
            </div>
            {!questionsVisible && (
            <button className="reload-btn" onClick={reloadQuestions}>
              {t('backToMainMenu')}
            </button>
          )}
          </>
        )}
      <div className="chat-input">
        <input 
          value={input} 
          onChange={(e) => setInput(e.target.value)} 
          placeholder="Type a message..." 
        />
        <button onClick={() => handleSend()}>{t('sendButton')}</button>
      </div>
    </div>
    </div>
  );
};

export default ChatBotWindow;
